import type { NoteEditorOverlayContextPayload } from '@components/common/NoteEditorOverlay/notesFeature.types'
import type { INote } from '@dataTypes/note.type'
import { NoteContextType } from '@dataTypes/note.type'

export type AppointmentNoteOverlayPayload = NoteEditorOverlayContextPayload & {
  patientId?: string
}

export type AppointmentNoteOverlayInput = {
  appointmentId: string
  patientId: string
  contextName: string
  noteId?: string
  /** Open the note in the editor (edit) instead of read-only view. */
  openInEditMode?: boolean
  onNotesSync?: (notes: Partial<INote>[]) => void
  /** Fires synchronously when Save succeeds so the host form table can update immediately. */
  onNoteSaved?: (note: INote) => void
}

export type ResolveAppointmentNoteOverlayInput = {
  appointmentId: string
  patientId: string
  contextName: string
  openFirstNote?: boolean
}

export function resolveAppointmentNoteOverlayPayload(
  input: ResolveAppointmentNoteOverlayInput,
): AppointmentNoteOverlayPayload {
  const { appointmentId, patientId, contextName, openFirstNote } = input

  if (!appointmentId) return {}

  return {
    contextId: appointmentId,
    contextType: NoteContextType.APPOINTMENT,
    contextName,
    patientId,
    ...(openFirstNote === true ? { openFirstNote: true } : {}),
  }
}
